import { useQuery } from '@tanstack/react-query';
import apiClient from '@shared/lib/apiClient';
import { useActiveOrganization } from '@shared/context/ActiveOrganizationContext';
export const useActiveUsers = () => {
    const { activeOrganizationId } = useActiveOrganization();
    return useQuery({
        queryKey: ['users', 'active', activeOrganizationId],
        queryFn: async () => {
            const { data } = await apiClient.get('/users/active');
            return data;
        },
        staleTime: 1000 * 60 * 2,
        enabled: !!activeOrganizationId,
    });
};
